
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchResources, fetchAllResources, fetchResourceCategories, rateResource, Resource, ResourceCategory } from '@/services/resourceService';

export const useResources = (filters?: {
  category?: string;
  type?: string;
  featured?: boolean;
  difficulty?: string;
  tags?: string[];
}) => {
  return useQuery({
    queryKey: ['resources', filters],
    queryFn: () => fetchResources(filters),
  });
};

export const useAllResources = () => {
  return useQuery({
    queryKey: ['all-resources'],
    queryFn: fetchAllResources,
  });
};

export const useResourceCategories = () => {
  return useQuery({
    queryKey: ['resource-categories'],
    queryFn: fetchResourceCategories,
  });
};

export const useResourceRating = () => {
  const handleRateResource = async (resourceId: string, rating: number, review?: string) => {
    try {
      await rateResource(resourceId, rating, review);
    } catch (error) {
      console.error('Error rating resource:', error);
      throw error;
    }
  };

  return {
    rateResource: handleRateResource
  };
};
